import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import type { HomePasosContent } from '../../models/home-pasos-content.model';
import { HomePasosService } from '../../services/home-pasos.service';
import { PASOS_IMAGE_DESKTOP_FALLBACK } from '../../utils/home-pasos-banner.mapper';
import { preparePasosTitleHtml } from '../../utils/home-pasos-html.util';

@Component({
  selector: 'app-home-pasos',
  templateUrl: './home-pasos.component.html',
  styleUrls: ['./home-pasos.component.scss'],
  standalone: false,
})
export class HomePasosComponent implements OnInit {
  content: HomePasosContent = buildInitialContent();
  titleSafe: SafeHtml = '';
  readonly anchorId = HOME_CONTENT_MOCK.anchors.comoFunciona;

  constructor(
    private readonly homePasosService: HomePasosService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.applyContent(this.content);
  }

  ngOnInit(): void {
    this.homePasosService.loadContent().subscribe((content) => {
      this.applyContent(content);
    });
  }

  private applyContent(content: HomePasosContent): void {
    this.content = content;
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(content.titleHtml); // NOSONAR — sanitize en mapper
  }
}

function buildInitialContent(): HomePasosContent {
  const mock = HOME_CONTENT_MOCK.pasos;
  return {
    eyebrow: mock.eyebrow,
    titleHtml: preparePasosTitleHtml(mock.titleHtml),
    items: mock.items.map((item) => ({ ...item })),
    imageDesktopSrc: PASOS_IMAGE_DESKTOP_FALLBACK,
  };
}
